/**
 * Textos explicativos dos campos do cadastro de Descontos (tooltips "i").
 *
 * Descrevem o comportamento efetivo do motor de calculo das plataformas, nao a
 * intencao do campo — mantenha alinhado com o codigo da API ao alterar regras.
 * As chaves seguem o nome da coluna do desconto.
 */
export const HINTS_DESCONTO = {
  aplicacallcenter:
    'Libera este desconto para pedidos do Call Center. Desmarcado, o desconto não é considerado nem exibido nesse canal. Atenção: representante que vende pelo Call Center segue a regra do Exibe FV.',

  aplicab2b:
    'Libera este desconto para o B2B — e também para SAC, Chat e Checkout, que seguem esta mesma flag. Desmarcado, o desconto não é considerado nem exibido nesses canais.',

  aplicafv:
    'Libera este desconto para o Força de Vendas. Esta flag também vale para o representante logado no Call Center (que segue a regra do FV, não a do Call).',

  aplicaautomatico:
    'Marcado, o desconto entra sozinho no preço quando o produto atende às regras, e o produto aparece como em promoção no Call/FV. Desmarcado, só vale quando o vendedor digita o percentual (flex) no Call/FV — no B2B o desconto é aplicado de todo modo.',

  percdesconto:
    'Percentual aplicado ao preço quando o desconto vale. Negativo = desconto, positivo = acréscimo (ex.: -10 aplica 10% de desconto).',

  percmaximodesc:
    'Teto do desconto manual (flex) que o vendedor pode conceder no produto enquanto esta política vale. Não é aplicado sozinho: apenas limita até onde o preço pode descer além do % Desc. Em branco, não há limite por esta política.',

  politica_id:
    'Código da política de desconto no ERP. Apenas informativo: serve para localizar o desconto na busca e é exibido ao vendedor no Call Center como identificador. Não altera o cálculo.',

  prioritaria:
    'Quando mais de um desconto vale para o mesmo produto, este é escolhido na frente dos demais. Perde apenas para um desconto marcado como Pri. Geral.',

  prioritariageral:
    'Prioridade máxima: se este desconto valer para o produto, ele é o aplicado e todos os outros são ignorados, inclusive os que alteram o preço de tabela.',

  visivel:
    'Marcado, o cliente vê o preço antigo riscado ao lado do preço com desconto (de R$ X por R$ Y) no B2B e Checkout. Desmarcado, o desconto continua aplicado normalmente, só não é evidenciado para o cliente.',

  exibeflag:
    'Apenas visual: exibe a etiqueta com o percentual de desconto (ex.: 10% OFF) sobre o produto no B2B/Call. Não altera o preço nem as regras de aplicação do desconto.',

  alteraprecotabela:
    'Aplica o desconto direto no preço de tabela, antes dos demais descontos — por isso soma com outra política válida para o mesmo produto (desconto sobre desconto). Desmarcado, o desconto concorre com as demais políticas e apenas uma é aplicada.',

  creditacontacorrente:
    'Marcado, quando o vendedor concede menos desconto do que esta política permite, a diferença economizada entra como crédito na conta corrente (verba) dele. Desmarcado, essa sobra não gera crédito. Vale para Call Center e FV.',

  politicacontacorrente:
    'Marcado, o desconto concedido por esta política é debitado da conta corrente (verba) do vendedor — quem paga o desconto é ele. Desmarcado, o desconto é absorvido pela empresa e não consome verba. Vale para Call Center e FV.',

  validausuario:
    'Sim: o desconto só vale quando o Cód. RCA/Operador da restrição é o do usuário logado que está vendendo. Não: a comparação usa o representante/operador da carteira do cliente.',

  produtoprincipal_id:
    'Restringe o desconto a uma família de produtos: informado o código do produto principal (modelo), o desconto vale para todos os produtos vinculados a ele, não só o principal. Vazio, não restringe. Produtos sem produto principal cadastrado não são alcançados.',
};

export default HINTS_DESCONTO;
